export default __webpack_public_path__ + "static/media/bg-image-daytime.bf5e0ad4.jpg";